import '../modals.css';

import { useRecoilValue } from 'recoil';
import { userConfigState } from '../../../recoil/atoms/userConfigState';
import { useOpenGlobalModal } from '../../../recoil/hooks/useOpenGlobalModal';

import CloseIcon from '@mui/icons-material/Close';
import BuildIcon from '@mui/icons-material/Build';
import PermScanWifiRoundedIcon from '@mui/icons-material/PermScanWifiRounded';

import { translate } from '../../../../common/language/translations';
import { RoleConfig } from '../../../types/tenant';
import { IconButton } from '../../controls/buttons/IconButton';
import { RoleConfigWeightBar } from '../../display/visualization/RoleConfigWeightBar';
import { positionGroupToPositions } from '../../../static/constants/positions';
import { isLimitedRoleConfig, roleConfigIsBeingComputed } from '../../../utils/metricUtils';
import { getTextDisplayPositions } from '../../../utils/positionUtils';


interface RoleInfoModalProps {
  closeModal: () => void;
  roleConfig: RoleConfig;
}

export const RoleInfoModal: React.FC<RoleInfoModalProps> = ({ closeModal, roleConfig }) => {

  const userConfig = useRecoilValue(userConfigState);

  const { openTextModal } = useOpenGlobalModal();

  const isBeingComputed = roleConfigIsBeingComputed(roleConfig);

  const isLimited = isLimitedRoleConfig(roleConfig);

  return (
    <div className='modal-root-container role-info-modal-root'>

      {isLimited && (
        <IconButton
          icon={<PermScanWifiRoundedIcon style={{ fontSize: 20, marginBottom: -1 }} />}
          onClick={() => openTextModal(
            translate('limitedRoleConfig', userConfig?.language),
            translate('limitedRoleConfigInfo', userConfig?.language),
            { infoType: 'infoIcon', titleKey: 'limitedRoleConfig' },
            true,
          )}
          size={30}
          style={{ position: 'absolute', top: 12, left: 12 }}
        />
      )}

      <IconButton
        icon={<CloseIcon style={{ fontSize: 24 }} />}
        onClick={closeModal}
        size={30}
        style={{ position: 'absolute', top: 12, right: 12 }}
        startWhite={true}
      />

      <div className='modal-root-title'>
        {roleConfig.name}
      </div>

      <div className='modal-divider modal-root-title-divider' />

      <div className='role-info-modal-text' style={{ marginTop: '4vh' }}>
        <b>
          {roleConfig.name}
        </b>
        {translate('roleInfoModalText1', userConfig?.language)}
        {' '}
        {getTextDisplayPositions(positionGroupToPositions[roleConfig.positionGroup], userConfig?.language)}
        {'.'}
      </div>

      <div className='role-info-modal-text' style={{ marginTop: '2vh' }}>
        {translate('roleInfoModalText2', userConfig?.language)}
      </div>

      <div className='role-info-modal-text' style={{ marginTop: '2vh' }}>
        {translate('roleInfoModalText3', userConfig?.language)}
      </div>

      {isBeingComputed && (
        <div className='role-info-modal-being-computed-section'>
          <BuildIcon style={{ fontSize: 18, marginTop: 1 }} />
          {translate('roleInfoModalText4', userConfig?.language)}
        </div>
      )}

      <div className='role-info-modal-role-config-weights'>
        <RoleConfigWeightBar
          roleConfig={roleConfig}
        />
      </div>

    </div>
  );
};
